

export const LOGINREQUEST = "LOGINREQUEST";
export const LOGINSUCCESS = "LOGINSUCCESS";
export const LOGINFAILURE = "LOGINFAILURE";

export const LOGOUT = "LOGOUT";

export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';

export const BOARDREQUEST = "BOARDREQUEST";
export const BOARDSUCCESS = "BOARDSUCCESS";
export const BOARDFAILURE = "BOARDFAILURE";

export const MEDIUMREQUEST = "MEDIUMREQUEST";
export const MEDIUMSUCCESS = "MEDIUMSUCCESS";
export const MEDIUMFAILURE = "MEDIUMFAILURE";

export const STANDARDREQUEST = "STANDARDREQUEST";
export const STANDARDSUCCESS = "STANDARDSUCCESS";
export const STANDARDFAILURE = "STANDARDFAILURE";

export const SEMESTERREQUEST = "SEMESTERREQUEST";
export const SEMESTERSUCCESS = "SEMESTERSUCCESS";
export const SEMESTERFAILURE = "SEMESTERFAILURE";

export const SUBJECTREQUEST = "SUBJECTREQUEST";
export const SUBJECTSUCCESS = "SUBJECTSUCCESS";
export const SUBJECTFAILURE = "SUBJECTFAILURE";

export const NOTICEREQUEST = "NOTICEREQUEST";
export const NOTICESUCCESS = "NOTICESUCCESS";
export const NOTICEFAILURE = "NOTICEFAILURE";

export const SELECTEDDATA = "SELECTEDDATA";

export const HEADERPATH = "HEADERPATH";

export const RANDOMDATA = "RANDOMDATA"

export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';

export const GET_PAPER_ID = 'GET_PAPER_ID'

export const STANDARDAUTOREQUEST = "STANDARDAUTOREQUEST";
export const STANDARDAUTOSUCCESS = "STANDARDAUTOSUCCESS";
export const STANDARDAUTOFAILURE = "STANDARDAUTOFAILURE";

export const SEMESTERAUTOREQUEST = "SEMESTERAUTOREQUEST";
export const SEMESTERAUTOSUCCESS = "SEMESTERAUTOSUCCESS";
export const SEMESTERAUTOFAILURE = "SEMESTERAUTOFAILURE";

export const SUBJECTAUTOREQUEST = "SUBJECTAUTOREQUEST";
export const SUBJECTAUTOSUCCESS = "SUBJECTAUTOSUCCESS";
export const SUBJECTAUTOFAILURE = "SUBJECTAUTOFAILURE";
